var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-group" },
    [
      _c(
        "span",
        {
          staticClass: "input-group-addon",
          class: _vm.addonClass,
          attrs: { id: "sizing-addon" + _vm.id }
        },
        [
          _c("span", {
            staticClass: "glyphicon",
            class: _vm.iconString,
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _c("StoreConnectedInput", {
        staticClass: "form-control",
        class: _vm.inputClass,
        attrs: {
          action: _vm.action,
          store: _vm.store,
          name: _vm.name,
          "sub-prop": _vm.subProp,
          field: _vm.field,
          "aria-describedby": "sizing-addon" + _vm.id,
          readonly: _vm.readonly,
          debounce: _vm.debounce,
          required: _vm.required,
          placeholder: _vm.placeholder
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }